import { render, staticRenderFns } from "./PaymentCheckEmail2.vue?vue&type=template&id=5c836266"
import script from "./PaymentCheckEmail2.vue?vue&type=script&lang=js"
export * from "./PaymentCheckEmail2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports